import React from 'react'
import { t } from '../../../i18n'
import Icon from '../../shared/icon'
import { CommandButton, ControlGroupKey } from '../types'
import ActionButton from './ActionButton'

const scope = 'controls'

const buttonClassName =
  'btn w-100 h-100 d-inline-flex align-items-center justify-content-center gap-2 controls-actions-btn-tall'

interface Props {
  groupKey: ControlGroupKey
  commands: CommandButton[]
  cardClassName?: string
}

// The backend shows exactly one of the pair (see Controls::CommandsController#command_visible?),
// so whichever arrives is the action available right now.
const OrdersLayout = ({ groupKey, commands, cardClassName }: Props) => {
  const stop = commands.find(c => c.command === 'stop_receiving_orders')
  const resume = commands.find(c => c.command === 'resume_receiving_orders')
  const command = stop ?? resume

  return (
    <div className={cardClassName ?? 'card mb-3'}>
      <div className="card-body">
        <h6 className="card-title mb-3">{t(`groups.${groupKey}`, { scope })}</h6>
        {command ? (
          <div className="controls-actions-grid-one">
            <ActionButton
              command={command}
              buttonClassName={`${buttonClassName} ${stop ? 'btn-danger' : 'btn-success'}`}
              icon={<Icon name={stop ? 'circleStop' : 'play'} color="currentColor" />}
            />
          </div>
        ) : (
          <div className="text-muted fst-italic">—</div>
        )}
      </div>
    </div>
  )
}

export default OrdersLayout
